import React from 'react';
import { useGetInboxNotificationsQuery } from 'src/services/api/inboxApi';
import { getUnreadInboxNotificationCount } from 'src/utils/NotificationsUtils';

import { NotificationBadge } from 'src/components/UI/Badges';

export const InboxNotificationBadge = () => {
  const { data: inboxNotifications } = useGetInboxNotificationsQuery();

  const unreadNotificationCount = React.useMemo(
    () => getUnreadInboxNotificationCount(inboxNotifications),
    [inboxNotifications],
  );

  return (
    <NotificationBadge
      showZero={false}
      isSidebar
      content={unreadNotificationCount}
    />
  );
};
